import React from "react";
import "./FrameView.css";

type FrameViewProps = {
    src: string
}

class FrameView extends React.Component<FrameViewProps, any> {
    render() {
        return <iframe className="FrameView" src={this.props.src}/>
    }
}

export default FrameView;